export function orderSchedule(order) {
  if (order?.schedule) return order.schedule;
  if (order?.pickupMode !== 'scheduled') return null;
  return { mode: 'scheduled', pickupAt: order.pickupAt, timezone: order.pickupTimezone, prepareAt: order.pickupPrepareAt, state: order.pickupState, releasedAt: order.pickupReleasedAt, canPrepare: order.pickupState === 'released' };
}
export function isAwaitingPreparation(order) {
  const schedule = orderSchedule(order);
  return schedule?.mode === 'scheduled' && schedule.canPrepare !== true && schedule.state !== 'cancelled';
}
export function pickupLabel(order) {
  const schedule = orderSchedule(order);
  if (schedule?.mode !== 'scheduled') return '';
  try { return `Retrait le ${new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: schedule.timezone || 'Europe/Paris' }).format(new Date(schedule.pickupAt))} (${schedule.timezone || 'Europe/Paris'})`; }
  catch { return 'Horaire de retrait à vérifier'; }
}
export function scheduleLabel(order) {
  const schedule = orderSchedule(order);
  if (schedule?.mode !== 'scheduled') return '';
  return `${schedule.state === 'reconciliation_required' ? 'À vérifier avec le client — paiement reçu, créneau à confirmer' : isAwaitingPreparation(order) ? 'À venir — précommande' : 'Précommande'} · ${pickupLabel(order)}`;
}
export function preparationStartedAt(order) { return orderSchedule(order)?.releasedAt || order?.orderedAt || order?.createdAt; }
